// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "style/" + chunkId + "." + "6401343fa8e493c6ad8a" + ".css";
};